import type { NDateLocale } from './enUS'
import { fr } from 'date-fns/locale'

const dateFrFR: NDateLocale = {
  name: 'fr-FR',
  locale: fr
}

export default dateFrFR
